import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { CountryDropdown } from "react-country-region-selector";
import { Link } from "react-router-dom";
import { useAdminUserList } from "../hooks/useAdminUserList";
import "../components/App.css";

const AdminReferAndEarn = () => {
  const {
    country,
    setCountry,
    id,
    setId,
    users,
    loadingUsers,
    loadError,
    loadedFromCache,
    applyFilters,
    refreshUsers,
  } = useAdminUserList();

  return (
    <Container>
        <Typography
          variant="h4"
          className="admin-message-title"
          gutterBottom
        >
          User Earnings
        </Typography>
        <Box className="admin-message-form-container">
          <CountryDropdown
            value={country}
            onChange={setCountry}
            labelType="full"
            className="admin-country-dropdown"
          />
          <TextField
            id="outlined-basic"
            label="User ID"
            fullWidth
            value={id}
            onChange={(event) => setId(event.target.value)}
            size="small"
            variant="outlined"
            className="admin-user-id-input"
            style={{ marginBottom: "1rem" }}
          />
          <Button
            variant="contained"
            color="success"
            onClick={applyFilters}
            className="admin-filter-button"
            disabled={loadingUsers}
          >
            {loadingUsers ? "Loading..." : "Filter"}
          </Button>
          <Button
            variant="outlined"
            color="success"
            onClick={refreshUsers}
            disabled={loadingUsers}
            sx={{ ml: 1 }}
          >
            Refresh
          </Button>
        </Box>

        {loadedFromCache && !loadingUsers && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Showing cached user list. Click Refresh for the latest data.
          </Alert>
        )}

        {loadError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {loadError}
          </Alert>
        )}

        <TableContainer component={Paper} style={{ marginTop: "2rem" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>User ID</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingUsers ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress size={28} color="success" />
                  </TableCell>
                </TableRow>
              ) : users.length > 0 ? (
                users.map((user) => (
                  <TableRow key={user._id}>
                    <TableCell>{`${user.fName || ""} ${user.lName || ""}`.trim()}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Link to={`/admin/refer-and-earn/${user._id}`}>
                        {user._id}
                      </Link>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No users found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
    </Container>
  );
};

export default AdminReferAndEarn;
